module.exports = __webpack_public_path__ + "toBride1-we-g-w.24a58694.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-g-w.jpg
// module id = tJ02
// module chunks = 0